import { useSelector } from "react-redux";

export const useTranslation = () => {
    const translations = useSelector(state => state.translations.translations);
    const t = (key) => {
        return translations[key] || key
    };

    const tHtml = (key) => (
        <span
        dangerouslySetInnerHTML={{
            __html: translations[key] || key
        }}
        />
    );
    
    return { t, tHtml, translations };
};
